// @flow
import { FormattedMessage, useIntl } from 'react-intl';
import isEqual from 'react-fast-compare';
import PageTitle from '../../components/PageTitle/PageTitle';
import React from 'react';
import { safelyRender } from '../../utils/safelyRender';
import SaveSearch from '../../components/SaveSearch/SaveSearch';
import styles from './CategoryFooter.module.scss';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import TextCollapse from '@liveauctioneers/caterwaul-components/lib/TextCollapse/TextCollapse';

type Props = $ReadOnly<{|
    archivedSearch: boolean,
    campaignId?: any,
    category: any,
    deleteSavedSearch: Function,
    isLoading: boolean,
    pageLabel: string,
    saveSearchCheckState: any,
    saveSearchState: any,
    submitSaveSearch: Function,
    totalItemsFound: number,
|}>;

export const CategoryFooter = (props: Props) => {
    const {
        archivedSearch,
        campaignId,
        category,
        deleteSavedSearch,
        isLoading,
        pageLabel,
        saveSearchCheckState,
        saveSearchState,
        submitSaveSearch,
        totalItemsFound,
    } = props;

    const { formatMessage } = useIntl();

    const displayBasedOnTotalItemsFound = totalItemsFound > 0;
    const tooltipMessage = <FormattedMessage id="follow_search_tooltip" values={{ token: pageLabel }} />;
    const isCampaignPage = Boolean(campaignId);

    return !isLoading && category.description && !archivedSearch ? (
        <div className={styles.footerContainer}>
            <div className={styles.categoryTitleContainer}>
                <div className={styles.titleLabel}>
                    <PageTitle className={styles.categoryTitle} title={pageLabel} />
                </div>
                {displayBasedOnTotalItemsFound && (
                    <div className={styles.saveSearchWrapper}>
                        {!isCampaignPage && (
                            <SaveSearch
                                deleteSavedSearch={deleteSavedSearch}
                                primary
                                saveSearchCheckState={saveSearchCheckState}
                                saveSearchState={saveSearchState}
                                submitSaveSearch={submitSaveSearch}
                                tooltipMessage={tooltipMessage}
                            />
                        )}
                    </div>
                )}
            </div>
            <div className={styles.categoryDescription}>
                <TextCollapse
                    className={styles.toggleClass}
                    collapseText={formatMessage({ id: 'less' })}
                    expandText={formatMessage({ id: 'more' })}
                    minHeightPx={105}
                    content={<Text secondary>{safelyRender(category.description, 'span')}</Text>}
                />
            </div>
        </div>
    ) : null;
};

export default React.memo<Props>(CategoryFooter, isEqual);
